import {
  call,
  put,
  race,
  select,
  take,
  takeEvery,
} from 'redux-saga/effects'

import { fetch } from '../../../utils/api'

import * as types from './types'
import { generateSearchURL } from './selectors'

function * getSearchURL (...args) {
  const searchState = yield select((state) => state.search)

  return yield call(generateSearchURL, searchState, searchState.endpoint, ...args)
}

function * setBookmarkableURL (...args) {
  // Get a shallow clone of the search state
  const searchState = { ...yield select((state) => state.search) }

  // Delete eventUUID as that'll get put in the URL otherwise
  delete searchState.eventUUID

  // Generate the querystring base on a blank URL (i.e. "this page")
  const url = yield call(generateSearchURL, searchState, '', ...args)

  // Now push that URL to the history stack, saving the current parameters that generated that state
  // into the history record's state
  // TODO: use pushState and popState to do this properly.
  history.replaceState && history.replaceState({ ...searchState, ...args[0] }, '', url)
}

function * getSearchResults (url) {
  yield put({ type: types.LOADING_START })

  try {
    const { ok, data: result } = yield call(fetch, 'GET', url)

    if (ok) {
      yield put({
        type: types.STORE_RESULTS,
        payload: result,
      })
    }
  } finally {
    yield put({ type: types.LOADING_END })
  }
}

function * performSearch () {
  const url = yield call(getSearchURL)
  yield call(getSearchResults, url)
  yield call(setBookmarkableURL)
}

function * getResultsPage ({ payload: { page } }) {
  const url = yield call(getSearchURL, { page })
  yield call(getSearchResults, url)
  yield call(setBookmarkableURL, { page })
}

function * toggleWishlist ({ payload: { property } }) {
  const wishlistToggleEndpoint = yield select((state) => state.search.wishlistToggleEndpoint)

  try {
    const { ok, data } = yield call(
      fetch,
      'POST',
      wishlistToggleEndpoint,
      { uuid: property },
      { 'Content-Type': 'application/json' }
    )

    if (ok) {
      yield put({
        type: types.TOGGLE_WISHLIST_SUCCESS,
        payload: { property, wishlisted: data.wishlisted },
      })

      if (data.is_authenticated === false){
        // we add the accommodation id to the hidden input fields of the sign-up and sign-in call to action forms
        // these forms are "outside" of react.
        let accommodationIdInputOnSignupForm = document.getElementById("id_signup_event_accommodation_id");
        accommodationIdInputOnSignupForm.value = data.event_accommodation;
        let accommodationIdInputOnSigninForm = document.getElementById("id_signin_event_accommodation_id");
        accommodationIdInputOnSigninForm.value = data.event_accommodation;

        // this opens up the signup call to action form (outside of react. When the form gets submitted it gets
        // submitted to a regular form endpoint on the backend)
        let dialogs = document.querySelectorAll('.signup-or-sign-in-call-to-action-modal');
                Array.prototype.forEach.call(dialogs, function (dialog) {
                    dialog.classList.add('dialog--modal-open')
                })
      }

      if (data.wishlisted === true) {
        window.incrementWishlistCount && window.incrementWishlistCount()

      } else if (data.wishlisted === false) {
        window.decrementWishlistCount && window.decrementWishlistCount()
      }
    } else {
      console.error('Wishlist fetch API failed:', data)
    }
  } catch (e) {
    console.error('Wishlist fetch request failed:', e.message)
  }
}

function * filter ({ payload: { type } }) {
  yield put({ type: types.SHOW_FILTER, payload: { type } })

  yield race({
    cancelled: take(types.CANCEL_FILTER),
    filter: take(types.APPLY_FILTER),
  })

  yield put({ type: types.HIDE_FILTER })
}

export default function * watcher () {
  yield takeEvery(types.PERFORM_SEARCH, performSearch)
  yield takeEvery(types.GET_RESULTS_PAGE, getResultsPage)

  yield takeEvery(types.TOGGLE_WISHLIST, toggleWishlist)

  yield takeEvery(types.FILTER, filter)

  yield takeEvery([ types.APPLY_FILTER, types.SET_ORDER ], performSearch)
}



// WEBPACK FOOTER //
// ./src/redux/modules/search/sagas.js